export enum MediaFilesListOrderingEnum {
  FileName = 'media_file.file_name',
  FileKey = 'media_file.file_key',
  Type = 'media_file.file_type',
  CreatedAt = 'media_file.created_at'
}
